import { useEffect } from "react";
import { useAuth } from "./identity-auth0-context";

export const SilentRenew: React.FC = () => {
  const { signinSilentCallback } = useAuth();

  useEffect(() => {
    signinSilentCallback?.();
  }, [signinSilentCallback]);

  return null; // or a loading indicator if needed
};

export default SilentRenew;
